import { Button } from "@heroui/react";
import { useId, useState } from "react";
import { ACTION_CLASS } from "../actions";
import { Icon } from "../Icon";
import { InDevelopmentNote, InDevelopmentTag } from "../InDevelopment";

type NewsActionsProps = {
  /** The item's page, opened in a new tab by «Apri link esterno». */
  url: string;
};

/**
 * The actions of a card opened in place: «Apri link esterno», and «Rielabora
 * con AI», which is in development: the label inside the button says so (its
 * description), and pressing it shows (and hides) the note under the row.
 * Nothing is asked of the api.
 */
export function NewsActions({ url }: NewsActionsProps) {
  const [noteOpen, setNoteOpen] = useState(false);
  const noteId = useId();
  const tagId = useId();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-end gap-[15px]">
        <Button size="sm" className={ACTION_CLASS} onPress={() => window.open(url, "_blank", "noreferrer")}>
          Apri link esterno
          <Icon name="arrowUpRightFromSquare" />
        </Button>
        <Button
          size="sm"
          className={ACTION_CLASS}
          aria-describedby={tagId}
          aria-expanded={noteOpen}
          aria-controls={noteOpen ? noteId : undefined}
          onPress={() => setNoteOpen((open) => !open)}
        >
          Rielabora con AI
          <Icon name="magicWand" />
          <InDevelopmentTag id={tagId} />
        </Button>
      </div>
      {noteOpen && (
        <InDevelopmentNote id={noteId} feature="Rielabora con AI">
          Per ora non produce alcun testo.
        </InDevelopmentNote>
      )}
    </div>
  );
}
